// -------------------------
// jQuery
// -------------------------
import $ from 'jquery';
window.$ = window.jQuery = $;

// Passive event fixes
['touchstart', 'touchmove', 'wheel', 'mousewheel'].forEach(ev =>
    $.event.special[ev] = {
        setup: function (_, ns, handle) {
            this.addEventListener(ev, handle, { passive: true });
        }
    }
);

// -------------------------
// Web Fonts
// -------------------------
import WebFont from 'webfontloader';
WebFont.load({
    google: {
        families: ['Inter:300, 400,500,600,700&display=swap']
    },
    active: function () {
        sessionStorage.fontsLoaded = true;
    }
});

// -------------------------
// Libraries
// -------------------------
import 'magnific-popup/dist/jquery.magnific-popup.min';

// -------------------------
// Modules
// -------------------------
import { initSwipers } from './modules/swipers.js';
import { initNavigation } from './modules/navigation.js';
import { initNavigationDropdowns } from './modules/navigation.js';
import initSearchAutocomplete from './modules/searchAutocomplete.js';
import initAccordion from './modules/accordion.js';
import initVideo from './modules/video.js';
import initWizard from './modules/wizard.js';
import initProductToggles from './modules/product.js';
import initTeamDialog from './modules/team.js';
import initFilterAndSort from './modules/filterAndSort.js';
import initQuickHelp from './modules/quickHelp.js';
import { initPagination } from './modules/pagination.js';

// -------------------------
// Initialise everything safely
// -------------------------
document.addEventListener('DOMContentLoaded', () => {
    initSwipers();
    initNavigation();
    initNavigationDropdowns();
    initSearchAutocomplete();
    initAccordion();
    initVideo();
    initWizard();
    initProductToggles();
    initTeamDialog();
    initFilterAndSort();
    initQuickHelp();

    // Pagination (supports multiple lists)
    document.querySelectorAll('.js-paginated-list').forEach(list => {
        initPagination('#' + list.id);
    });
});